import { Box, Flex } from "@chakra-ui/react";
import { About, AppImage, Footer, Navbar } from "../../shared/components";

function HomePage() {
  return (
    <Box backgroundColor="#FFFFFF" overflow={"hidden"}>
      <Navbar />
      <Flex flexDirection={"column"}>
        <Box>
          <AppImage />
        </Box>
        <Box>
          <About />
        </Box>
      </Flex>
      <Footer />
    </Box>
  );
}

export default HomePage;
